import { useEffect, useRef, useState } from 'react';
import { EquipmentDmgFilterType } from '@/entities/equipment';
import { useLocalStorageState } from '../local-storage.hooks';
import debounce from 'lodash/debounce';
import { RepairServiceLocalStorage } from '@/entities/repair-service';

interface RepairServiceFilterProps {
  setCurrentPage: (page: number) => void;
}

export const useRepairServiceFilter = ({
  setCurrentPage,
}: RepairServiceFilterProps) => {
  const [debouncedFilter, setDebouncedFilter] =
    useState<EquipmentDmgFilterType>({
      key: '',
    });
  const filtersEmptyRef = useRef<boolean>(true);

  /**
   * === Filter section ===
   */
  const [key, setKey] = useLocalStorageState({
    key: RepairServiceLocalStorage.KEY,
    removeOnClose: true,
  });

  const [status, setStatus] = useLocalStorageState({
    key: RepairServiceLocalStorage.STATUS,
    removeOnClose: true,
  });

  useEffect(() => {
    setDebouncedFilter((prev) => ({
      ...prev,
      key: key || '',
      status,
    }));

    filtersEmptyRef.current = !key && !status;
  }, [key, status]);

  const debounceFilterUpdate = (value: string) => {
    setKey(value);
    setCurrentPage(1);
    debounce((value: string) => {
      setDebouncedFilter((prev) => ({ ...prev, key: value }));
    }, 1000);
  };

  const searchByStatus = (value: string) => {
    setStatus(value);
    setCurrentPage(1);
    setDebouncedFilter((prev) => ({ ...prev, status: value }));
  };

  const clearFilters = () => {
    setKey('');
    setStatus('');
    setCurrentPage(1);
  };
  /**
   * === END OF Filter section ===
   */

  return {
    debouncedFilter,
    filtersEmpty: filtersEmptyRef.current,
    clearFilters,
    key,
    status,
    debounceFilterUpdate,
    searchByStatus,
  };
};
